import getAPIUrl from '../../config';
import { getApi } from '../../utils/apiCalls';
import removeFalsyValues from '../../utils/customMethods';
import { MemberApiProps } from './types';

const getMembers = async (data?: MemberApiProps): Promise<Error | any> => {
    try {
        const result = getApi(
            `${getAPIUrl()}/admins/members`,
            data
                ? removeFalsyValues({
                      size: data.memberSize,
                      page: data.currentPage,
                      sort: data.sort,
                      order: data.order,
                      name: data.memberSearchText,
                      additionPeriod: data.selectedMemberPeriod,
                      isActive: data.selectedMemberStatus && data.selectedMemberStatus === 'active',
                      conditionId: data.selectedDiabetesType.filter((dt) => dt.checked).map((dt) => dt.value),
                      employerId: data.employerId,
                  })
                : undefined,
        );
        return result;
    } catch (error: unknown) {
        const err = error as Error;
        return err;
    }
};

export default getMembers;
